export const FORM_MODE = {
  CREATE: "create",
  UPDATE: "update",
};

// Exact phrase the user must type to confirm closing their account. MUST stay in
// sync with the server-side check in flexibook-api/src/config/constants.js
// (CLOSE_ACCOUNT_CONFIRM_PHRASE) — the two packages can't share an import, so this
// is the source of truth on the UI side. If you change one, change the other.
export const CLOSE_ACCOUNT_CONFIRM_PHRASE = "close my account";

export const COLOUR = {
  GREEN: "green",
  GRAY: "gray",
  BLUE: "blue",
  YELLOW: "yellow",
  RED: "red",
};
export const STATUS_COLOR_CLASSES = {
  blue: "bg-accent-400",
  yellow: "bg-signal-amber-500",
  red: "bg-signal-red-500",
  green: "bg-signal-green-500",
};
export const COUNTRY_CODE_LIST = [
  { id: "CA", code: "+1", flag: "🇨🇦" },
  { id: "US", code: "+1", flag: "🇺🇸" },
  { id: "GB", code: "+44", flag: "🇬🇧" },
  { id: "AU", code: "+61", flag: "🇦🇺" },
  { id: "AE", code: "+971", flag: "🇦🇪" },
  { id: "AF", code: "+93", flag: "🇦🇫" },
  { id: "AL", code: "+355", flag: "🇦🇱" },
  { id: "DZ", code: "+213", flag: "🇩🇿" },
  { id: "AS", code: "+1", flag: "🇦🇸" },
  { id: "AD", code: "+376", flag: "🇦🇩" },
  { id: "AO", code: "+244", flag: "🇦🇴" },
  { id: "AI", code: "+1", flag: "🇦🇮" },
  { id: "AQ", code: "+672", flag: "🇦🇶" },
  { id: "AG", code: "+1", flag: "🇦🇬" },
  { id: "AR", code: "+54", flag: "🇦🇷" },
  { id: "AM", code: "+374", flag: "🇦🇲" },
  { id: "AW", code: "+297", flag: "🇦🇼" },
  { id: "AT", code: "+43", flag: "🇦🇹" },
  { id: "AZ", code: "+994", flag: "🇦🇿" },
  { id: "BS", code: "+1", flag: "🇧🇸" },
  { id: "BH", code: "+973", flag: "🇧🇭" },
  { id: "BD", code: "+880", flag: "🇧🇩" },
  { id: "BB", code: "+1", flag: "🇧🇧" },
  { id: "BY", code: "+375", flag: "🇧🇾" },
  { id: "BE", code: "+32", flag: "🇧🇪" },
  { id: "BZ", code: "+501", flag: "🇧🇿" },
  { id: "BJ", code: "+229", flag: "🇧🇯" },
  { id: "BM", code: "+1", flag: "🇧🇲" },
  { id: "BT", code: "+975", flag: "🇧🇹" },
  { id: "BO", code: "+591", flag: "🇧🇴" },
  { id: "BA", code: "+387", flag: "🇬🇦" },
  { id: "BW", code: "+267", flag: "🇧🇼" },
  { id: "BR", code: "+55", flag: "🇧🇷" },
  { id: "IO", code: "+246", flag: "🇮🇴" },
  { id: "VG", code: "+1", flag: "🇻🇬" },
  { id: "BN", code: "+673", flag: "🇧🇳" },
  { id: "BG", code: "+359", flag: "🇧🇬" },
  { id: "BF", code: "+226", flag: "🇧🇫" },
  { id: "BI", code: "+257", flag: "🇧🇮" },
  { id: "KH", code: "+855", flag: "🇰🇭" },
  { id: "CM", code: "+237", flag: "🇨🇲" },
  { id: "CV", code: "+238", flag: "🇨🇻" },
  { id: "KY", code: "+1", flag: "🇰🇾" },
  { id: "CF", code: "+236", flag: "🇨🇫" },
  { id: "TD", code: "+235", flag: "🇹🇩" },
  { id: "CL", code: "+56", flag: "🇨🇱" },
  { id: "CN", code: "+86", flag: "🇨🇳" },
  { id: "CX", code: "+61", flag: "🇨🇽" },
  { id: "CC", code: "+61", flag: "🇨🇨" },
  { id: "CO", code: "+57", flag: "🇨🇴" },
  { id: "KM", code: "+269", flag: "🇰🇲" },
  { id: "CK", code: "+682", flag: "🇨🇰" },
  { id: "CR", code: "+506", flag: "🇨🇷" },
  { id: "HR", code: "+385", flag: "🇭🇷" },
  { id: "CU", code: "+53", flag: "🇨🇺" },
  { id: "CW", code: "+599", flag: "🇨🇼" },
  { id: "CY", code: "+357", flag: "🇨🇾" },
  { id: "CZ", code: "+420", flag: "🇨🇿" },
  { id: "CD", code: "+243", flag: "🇨🇩" },
  { id: "DK", code: "+45", flag: "🇩🇰" },
  { id: "DJ", code: "+253", flag: "🇩🇯" },
  { id: "DM", code: "+1", flag: "🇩🇲" },
  { id: "DO", code: "+1", flag: "🇩🇴" },
  { id: "TL", code: "+670", flag: "🇹🇱" },
  { id: "EC", code: "+593", flag: "🇪🇨" },
  { id: "EG", code: "+20", flag: "🇪🇬" },
  { id: "SV", code: "+503", flag: "🇸🇻" },
  { id: "GQ", code: "+240", flag: "🇬🇶" },
  { id: "ER", code: "+291", flag: "🇪🇷" },
  { id: "EE", code: "+372", flag: "🇪🇪" },
  { id: "ET", code: "+251", flag: "🇪🇹" },
  { id: "FK", code: "+500", flag: "🇫🇰" },
  { id: "FO", code: "+298", flag: "🇫🇴" },
  { id: "FJ", code: "+679", flag: "🇫🇯" },
  { id: "FI", code: "+358", flag: "🇫🇮" },
  { id: "FR", code: "+33", flag: "🇫🇷" },
  { id: "PF", code: "+689", flag: "🇵🇫" },
  { id: "GA", code: "+241", flag: "🇬🇦" },
  { id: "GM", code: "+220", flag: "🇬🇲" },
  { id: "GE", code: "+995", flag: "🇬🇪" },
  { id: "DE", code: "+49", flag: "🇩🇪" },
  { id: "GH", code: "+233", flag: "🇬🇭" },
  { id: "GI", code: "+350", flag: "🇬🇮" },
  { id: "GR", code: "+30", flag: "🇬🇷" },
  { id: "GL", code: "+299", flag: "🇬🇱" },
  { id: "GD", code: "+1", flag: "🇬🇩" },
  { id: "GU", code: "+1", flag: "🇬🇺" },
  { id: "GT", code: "+502", flag: "🇬🇹" },
  { id: "GG", code: "+44", flag: "🇬🇬" },
  { id: "GN", code: "+224", flag: "🇬🇳" },
  { id: "GW", code: "+245", flag: "🇬🇼" },
  { id: "GY", code: "+592", flag: "🇬🇾" },
  { id: "HT", code: "+509", flag: "🇭🇹" },
  { id: "HN", code: "+504", flag: "🇭🇳" },
  { id: "HK", code: "+852", flag: "🇭🇰" },
  { id: "HU", code: "+36", flag: "🇭🇺" },
  { id: "IS", code: "+354", flag: "🇮🇸" },
  { id: "IN", code: "+91", flag: "🇮🇳" },
  { id: "ID", code: "+62", flag: "🇮🇩" },
  { id: "IR", code: "+98", flag: "🇮🇷" },
  { id: "IQ", code: "+964", flag: "🇮🇶" },
  { id: "IE", code: "+353", flag: "🇮🇪" },
  { id: "IM", code: "+44", flag: "🇮🇲" },
  { id: "IL", code: "+972", flag: "🇮🇱" },
  { id: "IT", code: "+39", flag: "🇮🇹" },
  { id: "CI", code: "+225", flag: "🇨🇮" },
  { id: "JM", code: "+1", flag: "🇯🇲" },
  { id: "JP", code: "+81", flag: "🇯🇵" },
  { id: "JE", code: "+44", flag: "🇯🇪" },
  { id: "JO", code: "+962", flag: "🇯🇴" },
  { id: "KZ", code: "+7", flag: "🇰🇿" },
  { id: "KE", code: "+254", flag: "🇰🇪" },
  { id: "KI", code: "+686", flag: "🇰🇮" },
  { id: "XK", code: "+383", flag: "🇽🇰" },
  { id: "KW", code: "+965", flag: "🇰🇼" },
  { id: "KG", code: "+996", flag: "🇰🇬" },
  { id: "LA", code: "+856", flag: "🇱🇦" },
  { id: "LV", code: "+371", flag: "🇱🇻" },
  { id: "LB", code: "+961", flag: "🇱🇧" },
  { id: "LS", code: "+266", flag: "🇱🇸" },
  { id: "LR", code: "+231", flag: "🇱🇷" },
  { id: "LY", code: "+218", flag: "🇱🇾" },
  { id: "LI", code: "+423", flag: "🇱🇮" },
  { id: "LT", code: "+370", flag: "🇱🇹" },
  { id: "LU", code: "+352", flag: "🇱🇺" },
  { id: "MO", code: "+853", flag: "🇲🇴" },
  { id: "MK", code: "+389", flag: "🇲🇰" },
  { id: "MG", code: "+261", flag: "🇲🇬" },
  { id: "MW", code: "+265", flag: "🇲🇼" },
  { id: "MY", code: "+60", flag: "🇲🇾" },
  { id: "MV", code: "+960", flag: "🇲🇻" },
  { id: "ML", code: "+223", flag: "🇲🇱" },
  { id: "MT", code: "+356", flag: "🇲🇴" },
  { id: "MH", code: "+692", flag: "🇲🇭" },
  { id: "MR", code: "+222", flag: "🇲🇷" },
  { id: "MU", code: "+230", flag: "🇲🇺" },
  { id: "YT", code: "+262", flag: "🇾🇹" },
  { id: "MX", code: "+52", flag: "🇲🇽" },
  { id: "FM", code: "+691", flag: "🇫🇲" },
  { id: "MD", code: "+373", flag: "🇲🇩" },
  { id: "MC", code: "+377", flag: "🇲🇨" },
  { id: "MN", code: "+976", flag: "🇲🇳" },
  { id: "ME", code: "+382", flag: "🇲🇪" },
  { id: "MS", code: "+1", flag: "🇲🇸" },
  { id: "MA", code: "+212", flag: "🇲🇦" },
  { id: "MZ", code: "+258", flag: "🇲🇿" },
  { id: "MM", code: "+95", flag: "🇲🇲" },
  { id: "NA", code: "+264", flag: "🇳🇦" },
  { id: "NR", code: "+674", flag: "🇳🇷" },
  { id: "NP", code: "+977", flag: "🇳🇵" },
  { id: "NL", code: "+31", flag: "🇳🇱" },
  { id: "NC", code: "+687", flag: "🇳🇨" },
  { id: "NZ", code: "+64", flag: "🇳🇿" },
  { id: "NI", code: "+505", flag: "🇳🇮" },
  { id: "NE", code: "+227", flag: "🇳🇪" },
  { id: "NG", code: "+234", flag: "🇳🇬" },
  { id: "NU", code: "+683", flag: "🇳🇺" },
  { id: "NF", code: "+672", flag: "🇳🇫" },
  { id: "KP", code: "+850", flag: "🇰🇵" },
  { id: "MP", code: "+1", flag: "🇲🇵" },
  { id: "NO", code: "+47", flag: "🇳🇴" },
  { id: "OM", code: "+968", flag: "🇴🇲" },
  { id: "PK", code: "+92", flag: "🇵🇰" },
  { id: "PW", code: "+680", flag: "🇵🇼" },
  { id: "PS", code: "+970", flag: "🇵🇸" },
  { id: "PA", code: "+507", flag: "🇵🇦" },
  { id: "PG", code: "+675", flag: "🇵🇬" },
  { id: "PY", code: "+595", flag: "🇵🇾" },
  { id: "PE", code: "+51", flag: "🇵🇪" },
  { id: "PH", code: "+63", flag: "🇵🇭" },
  { id: "PN", code: "+64", flag: "🇵🇳" },
  { id: "PL", code: "+48", flag: "🇵🇱" },
  { id: "PT", code: "+351", flag: "🇵🇹" },
  { id: "PR", code: "+1", flag: "🇵🇷" },
  { id: "QA", code: "+974", flag: "🇶🇦" },
  { id: "CG", code: "+242", flag: "🇨🇬" },
  { id: "RE", code: "+262", flag: "🇷🇪" },
  { id: "RO", code: "+40", flag: "🇷🇴" },
  { id: "RU", code: "+7", flag: "🇷🇺" },
  { id: "RW", code: "+250", flag: "🇷🇼" },
  { id: "BL", code: "+590", flag: "🇧🇱" },
  { id: "SH", code: "+290", flag: "🇸🇭" },
  { id: "KN", code: "+1", flag: "🇰🇳" },
  { id: "LC", code: "+1", flag: "🇲🇨" },
  { id: "MF", code: "+590", flag: "🇲🇫" },
  { id: "PM", code: "+508", flag: "🇵🇲" },
  { id: "VC", code: "+1", flag: "🇻🇨" },
  { id: "WS", code: "+685", flag: "🇼🇸" },
  { id: "SM", code: "+378", flag: "🇸🇲" },
  { id: "ST", code: "+239", flag: "🇸🇹" },
  { id: "SA", code: "+966", flag: "🇸🇦" },
  { id: "SN", code: "+221", flag: "🇸🇳" },
  { id: "RS", code: "+381", flag: "🇷🇸" },
  { id: "SC", code: "+248", flag: "🇸🇨" },
  { id: "SL", code: "+232", flag: "🇸🇱" },
  { id: "SG", code: "+65", flag: "🇸🇬" },
  { id: "SX", code: "+1", flag: "🇸🇽" },
  { id: "SK", code: "+421", flag: "🇸🇰" },
  { id: "SI", code: "+386", flag: "🇸🇮" },
  { id: "SB", code: "+677", flag: "🇸🇧" },
  { id: "SO", code: "+252", flag: "🇸🇴" },
  { id: "ZA", code: "+27", flag: "🇿🇦" },
  { id: "KR", code: "+82", flag: "🇰🇷" },
  { id: "SS", code: "+211", flag: "🇸🇸" },
  { id: "ES", code: "+34", flag: "🇪🇸" },
  { id: "LK", code: "+94", flag: "🇱🇰" },
  { id: "SD", code: "+249", flag: "🇸🇩" },
  { id: "SR", code: "+597", flag: "🇸🇷" },
  { id: "SJ", code: "+47", flag: "🇸🇯" },
  { id: "SZ", code: "+268", flag: "🇸🇿" },
  { id: "SE", code: "+46", flag: "🇸🇪" },
  { id: "CH", code: "+41", flag: "🇨🇭" },
  { id: "SY", code: "+963", flag: "🇸🇾" },
  { id: "TW", code: "+886", flag: "🇹🇼" },
  { id: "TJ", code: "+992", flag: "🇹🇯" },
  { id: "TZ", code: "+255", flag: "🇹🇿" },
  { id: "TH", code: "+66", flag: "🇹🇭" },
  { id: "TG", code: "+228", flag: "🇹🇬" },
  { id: "TK", code: "+690", flag: "🇹🇰" },
  { id: "TO", code: "+676", flag: "🇹🇴" },
  { id: "TT", code: "+1", flag: "🇹🇹" },
  { id: "TN", code: "+216", flag: "🇹🇳" },
  { id: "TR", code: "+90", flag: "🇹🇷" },
  { id: "TM", code: "+993", flag: "🇹🇲" },
  { id: "TC", code: "+1", flag: "🇹🇨" },
  { id: "TV", code: "+688", flag: "🇹🇻" },
  { id: "VI", code: "+1", flag: "🇻🇮" },
  { id: "UG", code: "+256", flag: "🇺🇬" },
  { id: "UA", code: "+380", flag: "🇺🇦" },
  { id: "UY", code: "+598", flag: "🇺🇾" },
  { id: "UZ", code: "+998", flag: "🇺🇿" },
  { id: "VU", code: "+678", flag: "🇻🇺" },
  { id: "VA", code: "+39", flag: "🇻🇦" },
  { id: "VE", code: "+58", flag: "🇻🇪" },
  { id: "VN", code: "+84", flag: "🇻🇳" },
  { id: "WF", code: "+681", flag: "🇼🇫" },
  { id: "EH", code: "+212", flag: "🇪🇭" },
  { id: "YE", code: "+967", flag: "🇾🇪" },
  { id: "ZM", code: "+260", flag: "🇿🇲" },
  { id: "ZW", code: "+263", flag: "🇿🇼" },
];
export const CURRENCY_CODE_LIST = [
  { id: "AED", symbol: "د.إ" },
  { id: "AFN", symbol: "؋" },
  { id: "ALL", symbol: "L" },
  { id: "AMD", symbol: "֏" },
  { id: "ANG", symbol: "ƒ" },
  { id: "AOA", symbol: "Kz" },
  { id: "ARS", symbol: "$" },
  { id: "AUD", symbol: "$" },
  { id: "AWG", symbol: "ƒ" },
  { id: "AZN", symbol: "₼" },
  { id: "BAM", symbol: "KM" },
  { id: "BBD", symbol: "$" },
  { id: "BDT", symbol: "৳" },
  { id: "BGN", symbol: "лв" },
  { id: "BHD", symbol: ".د.ب" },
  { id: "BIF", symbol: "FBu" },
  { id: "BMD", symbol: "$" },
  { id: "BND", symbol: "$" },
  { id: "BOB", symbol: "Bs." },
  { id: "BRL", symbol: "R$" },
  { id: "BSD", symbol: "$" },
  { id: "BTN", symbol: "Nu." },
  { id: "BWP", symbol: "P" },
  { id: "BYN", symbol: "Br" },
  { id: "BZD", symbol: "BZ$" },
  { id: "CAD", symbol: "$" },
  { id: "CDF", symbol: "FC" },
  { id: "CHF", symbol: "CHF" },
  { id: "CLP", symbol: "$" },
  { id: "CNY", symbol: "¥" },
  { id: "COP", symbol: "$" },
  { id: "CRC", symbol: "₡" },
  { id: "CUP", symbol: "$" },
  { id: "CVE", symbol: "$" },
  { id: "CZK", symbol: "Kč" },
  { id: "DJF", symbol: "Fdj" },
  { id: "DKK", symbol: "kr" },
  { id: "DOP", symbol: "RD$" },
  { id: "DZD", symbol: "دج" },
  { id: "EGP", symbol: "£" },
  { id: "ERN", symbol: "Nfk" },
  { id: "ETB", symbol: "Br" },
  { id: "EUR", symbol: "€" },
  { id: "FJD", symbol: "$" },
  { id: "FKP", symbol: "£" },
  { id: "FOK", symbol: "kr" },
  { id: "GBP", symbol: "£" },
  { id: "GEL", symbol: "₾" },
  { id: "GHS", symbol: "₵" },
  { id: "GIP", symbol: "£" },
  { id: "GMD", symbol: "D" },
  { id: "GNF", symbol: "FG" },
  { id: "GTQ", symbol: "Q" },
  { id: "GYD", symbol: "$" },
  { id: "HKD", symbol: "$" },
  { id: "HNL", symbol: "L" },
  { id: "HRK", symbol: "kn" },
  { id: "HTG", symbol: "G" },
  { id: "HUF", symbol: "Ft" },
  { id: "IDR", symbol: "Rp" },
  { id: "ILS", symbol: "₪" },
  { id: "INR", symbol: "₹" },
  { id: "IQD", symbol: "ع.د" },
  { id: "IRR", symbol: "﷼" },
  { id: "ISK", symbol: "kr" },
  { id: "JMD", symbol: "J$" },
  { id: "JOD", symbol: "د.ا" },
  { id: "JPY", symbol: "¥" },
  { id: "KES", symbol: "KSh" },
  { id: "KGS", symbol: "с" },
  { id: "KHR", symbol: "៛" },
  { id: "KMF", symbol: "CF" },
  { id: "KPW", symbol: "₩" },
  { id: "KRW", symbol: "₩" },
  { id: "KWD", symbol: "د.ك" },
  { id: "KYD", symbol: "$" },
  { id: "KZT", symbol: "₸" },
  { id: "LAK", symbol: "₭" },
  { id: "LBP", symbol: "ل.ل" },
  { id: "LKR", symbol: "₨" },
  { id: "LRD", symbol: "$" },
  { id: "LSL", symbol: "L" },
  { id: "LYD", symbol: "ل.د" },
  { id: "MAD", symbol: "د.م." },
  { id: "MDL", symbol: "lei" },
  { id: "MGA", symbol: "Ar" },
  { id: "MKD", symbol: "ден" },
  { id: "MMK", symbol: "K" },
  { id: "MNT", symbol: "₮" },
  { id: "MOP", symbol: "MOP$" },
  { id: "MRU", symbol: "UM" },
  { id: "MUR", symbol: "₨" },
  { id: "MVR", symbol: "Rf" },
  { id: "MWK", symbol: "MK" },
  { id: "MXN", symbol: "$" },
  { id: "MYR", symbol: "RM" },
  { id: "MZN", symbol: "MT" },
  { id: "NAD", symbol: "$" },
  { id: "NGN", symbol: "₦" },
  { id: "NIO", symbol: "C$" },
  { id: "NOK", symbol: "kr" },
  { id: "NPR", symbol: "₨" },
  { id: "NZD", symbol: "$" },
  { id: "OMR", symbol: "ر.ع." },
  { id: "PAB", symbol: "B/." },
  { id: "PEN", symbol: "S/." },
  { id: "PGK", symbol: "K" },
  { id: "PHP", symbol: "₱" },
  { id: "PKR", symbol: "₨" },
  { id: "PLN", symbol: "zł" },
  { id: "PYG", symbol: "₲" },
  { id: "QAR", symbol: "ر.ق" },
  { id: "RON", symbol: "lei" },
  { id: "RSD", symbol: "дин." },
  { id: "RUB", symbol: "₽" },
  { id: "RWF", symbol: "FRw" },
  { id: "SAR", symbol: "ر.س" },
  { id: "SBD", symbol: "$" },
  { id: "SCR", symbol: "₨" },
  { id: "SDG", symbol: "ج.س." },
  { id: "SEK", symbol: "kr" },
  { id: "SGD", symbol: "$" },
  { id: "SHP", symbol: "£" },
  { id: "SLL", symbol: "Le" },
  { id: "SOS", symbol: "S" },
  { id: "SRD", symbol: "$" },
  { id: "SSP", symbol: "£" },
  { id: "STN", symbol: "Db" },
  { id: "SVC", symbol: "$" },
  { id: "SYP", symbol: "£" },
  { id: "SZL", symbol: "E" },
  { id: "THB", symbol: "฿" },
  { id: "TJS", symbol: "SM" },
  { id: "TMT", symbol: "m" },
  { id: "TND", symbol: "د.ت" },
  { id: "TOP", symbol: "T$" },
  { id: "TRY", symbol: "₺" },
  { id: "TTD", symbol: "TT$" },
  { id: "TVD", symbol: "$" },
  { id: "TWD", symbol: "NT$" },
  { id: "TZS", symbol: "TSh" },
  { id: "UAH", symbol: "₴" },
  { id: "UGX", symbol: "USh" },
  { id: "USD", symbol: "$" },
  { id: "UYU", symbol: "$U" },
  { id: "UZS", symbol: "сўм" },
  { id: "VES", symbol: "Bs." },
  { id: "VND", symbol: "₫" },
  { id: "VUV", symbol: "VT" },
  { id: "WST", symbol: "WS$" },
  { id: "XAF", symbol: "FCFA" },
  { id: "XCD", symbol: "$" },
  { id: "XOF", symbol: "CFA" },
  { id: "XPF", symbol: "₣" },
  { id: "YER", symbol: "﷼" },
  { id: "ZAR", symbol: "R" },
  { id: "ZMW", symbol: "ZK" },
  { id: "ZWL", symbol: "$" },
];
